import React, { useState } from 'react';
import RoomCard from './RoomCard';
import './Rooms.css';

const Rooms = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  // Phone and WhatsApp numbers
  const phoneNumber = '+918019472678';
  const whatsappNumber = '918019472678';
  const whatsappMessage = 'Hi! I want to enquire about room availability at AA GRAND HOTEL';

  const rooms = [
    {
      id: 1,
      name: 'Non-AC Room',
      type: 'non-ac',
      price: '₹1,200',
      shortStayPrice: '₹799',
      pricePer: 'per night',
      image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      amenities: ['TV', 'WiFi', 'Attached Bathroom', 'Ceiling Fan', 'Couple Friendly'],
      size: '220 sq ft',
      beds: '1 Double Bed',
      maxGuests: 2,
      rating: 4.5,
      description: 'Comfortable and budget-friendly room with all essential amenities. Perfect for travelers looking for a cozy stay without breaking the bank.',
      badge: '💲 Best Value'
    },
    {
      id: 2,
      name: 'AC Room',
      type: 'ac',
      price: '₹1,800',
      shortStayPrice: '₹1,099',
      pricePer: 'per night',
      image: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      amenities: ['AC', 'TV', 'WiFi', 'Attached Bathroom', 'Mini Fridge', 'Couple Friendly'],
      size: '280 sq ft',
      beds: '1 King Bed',
      maxGuests: 2,
      rating: 4.8,
      description: 'Air-conditioned room with modern amenities for a comfortable stay. Enjoy the perfect temperature and premium comfort.',
      badge: '⭐ Most Popular'
    },
    {
      id: 3,
      name: 'Deluxe AC Room',
      type: 'deluxe',
      price: '₹2,800',
      shortStayPrice: '₹1,699',
      pricePer: 'per night',
      image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      amenities: ['AC', 'TV', 'WiFi', 'Mini Bar', 'Living Area', 'Couple Friendly'],
      size: '400 sq ft',
      beds: '1 King Bed + Sofa',
      maxGuests: 3,
      rating: 4.9,
      description: 'Spacious AC room with premium amenities for a luxurious experience. Perfect for couples seeking extra space and comfort.',
      badge: '⭐ Couple Favorite'
    }
  ];

  // Get unique room types for filters
  const filterOptions = [
    { id: 'all', label: 'All Rooms' },
    { id: 'non-ac', label: 'Non-AC' },
    { id: 'ac', label: 'AC' },
    { id: 'deluxe', label: 'Deluxe' }
  ];

  // Filter rooms based on active filter
  const filteredRooms = activeFilter === 'all' 
    ? rooms 
    : rooms.filter(room => room.type === activeFilter);

  const handleFilterClick = (filterId) => {
    setActiveFilter(filterId);
  };

  // Handle phone call
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  // Handle WhatsApp chat
  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`,
      '_blank'
    );
  };

  return (
    <section className="rooms-page">
      {/* Hero Banner */}
      <div className="rooms-hero">
        <div className="rooms-hero-overlay">
          <div className="rooms-hero-content">
            <span className="rooms-hero-badge">✦ Our Collection</span>
            <h1 className="rooms-hero-title">
              Luxurious <span className="highlight">Rooms</span>
            </h1>
            <p className="rooms-hero-subtitle">
              Discover our range of thoughtfully designed rooms for every need
            </p>
          </div>
        </div>
      </div>

      {/* Rooms List */}
      <div className="rooms-list">
        <div className="rooms-list-container">
          {/* Room Type Filters */}
          <div className="rooms-filter">
            <span className="filter-label">Room Types:</span>
            <div className="filter-tags">
              {filterOptions.map((filter) => (
                <button
                  key={filter.id}
                  className={`filter-tag ${activeFilter === filter.id ? 'active' : ''}`}
                  onClick={() => handleFilterClick(filter.id)}
                >
                  {filter.label}
                </button>
              ))}
            </div>
            <span className="filter-count">{filteredRooms.length} rooms available</span>
          </div>

          {/* Rooms Grid */}
          <div className="rooms-grid">
            {filteredRooms.length > 0 ? (
              filteredRooms.map((room) => (
                <RoomCard 
                  key={room.id} 
                  room={room} 
                  phoneNumber={phoneNumber}
                  whatsappNumber={whatsappNumber}
                />
              ))
            ) : (
              <div className="no-rooms-message">
                <span className="no-rooms-icon">🔍</span>
                <h3>No rooms found</h3>
                <p>Try selecting a different room type</p>
              </div>
            )}
          </div>

          {/* Short Stay Section */}
          <div className="rooms-short-stay">
            <div className="short-stay-banner">
              <div className="short-stay-icon">⏰</div>
              <div className="short-stay-text">
                <h3>Short Stay Packages Available</h3>
                <p>Book our 4-hour stay packages at special rates. Perfect for quick getaways!</p>
              </div>
              <button onClick={handleCall} className="short-stay-cta">
                📞 Call for Booking →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rooms;